import { inject, observer } from 'mobx-react';
import propTypes from 'prop-types';

import { SubstitutionSection } from './SubstitutionSection.jsx';

export const _SubstitutionSectionWrapper = (props) => {
  const { parent, substRootStore } = props;
  const substSectionStores = substRootStore.getSubstSectionStores(parent);

  return (
    substSectionStores
      ? substSectionStores.map((substSectionStore) => (
        <SubstitutionSection
            key={substSectionStore.configurationMasterId}
            parentSkuID={parent.skuID}
            substSectionStore={substSectionStore}
            isLabelRef
        />
      ))
      : (
        <SubstitutionSection
            parentSkuID={parent.skuID}
            endOfSale={parent.endOfSale}
            isLabelRef={false}
        />
      )
  );
};

_SubstitutionSectionWrapper.propTypes = {
  parent: propTypes.object.isRequired,
  substRootStore: propTypes.object.isRequired
};
export const SubstitutionSectionWrapper = inject('substRootStore')(observer(_SubstitutionSectionWrapper));
